export default __webpack_public_path__ + "static/media/image_5.7831d26c.jpg";